module.exports = __webpack_public_path__ + "img/icon-project-default-cover.8974a79a.png";